import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Artist, ArtistsService, ExternalInvitation } from 'src/app/Services/artists.service';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { GalleryItems, GalleriesService } from 'src/app/Services/galleries.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { ResponseObject } from '../../Services/auth.service';
import { environment } from 'src/environments/environment';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.css'],
    providers: [AuthService, ArtistsService, GalleriesService],
    standalone: false
})
export class SignupComponent implements OnInit {
  public authConfig: AuthConfig = {};
  public invitationId!: string;
  public signupForm: UserSignupRequest = {} as UserSignupRequest;
  public isExternalInviteFound: boolean = false;
  public loginDialog: boolean = false;
  public invitedByUserFullName?: string;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private ngxSpinnerService: NgxSpinnerService,
    private artistService: ArtistsService,
    private authService: AuthService,
    private galleriesService: GalleriesService,
    private notificationsService: NotificationsService,
    private transloco: TranslocoService) { }

  public ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      //if the user is already authenticated, redirect them to the home
      this.router.navigate(['/']);
    }

    this.authConfig = this.authService.getAuthConfig();
   
  }



  private saveArtist() {
    var artist = new Artist();
    // artist.Name = this.signupForm.Name;
    artist.FirstName = this.signupForm.FirstName
    artist.LastName = this.signupForm.LastName
    artist.Email = this.signupForm.Email;
    artist.Password = this.signupForm.Password;
    artist.ConfirmPassword = this.signupForm.ConfirmPassword;
    artist.BusinessName = this.signupForm.BusinessName;

    this.ngxSpinnerService.show();
    this.artistService.saveArtist(artist).subscribe((response) => {
      this.ngxSpinnerService.hide();
      if (response.Success) {
        window.parent.location.href = 'https://artflow-pro.com/thanks-for-subscribing-to-artflow/';
        // //check if the angular application is running in an iframe or not
        // if (window.self === window.top) {
        //   //login now
        //   this.loginDialog = true;
        //   // this.ngxSpinnerService.show();
        //   // this.authService.login({ Username: artist.Email, Password: artist.Password }).subscribe((loginResponse: ResponseObject) => {
        //   //   if (loginResponse.Success) {
        //   //     //accrpt the invite now
        //   //     localStorage.setItem('isNewUser', 'true');
        //   //     this.acceptExternalUserRequest((success: boolean) => {
        //   //       //reload the window now after the invite got accepted
        //   //       window.location.reload();
        //   //     });
        //   //   }
        //   //   this.ngxSpinnerService.hide();
        //   // }, error => { console.error(error); this.ngxSpinnerService.hide(); });
        // } else {
        //   //Open Dialog Here......
        //   //user is viewing the site in the iframe so navigate him properly to the portal site
        //   if (environment.production && window.parent) {
        //     console.log('Window.parent exists and I am just behind the redirection');
        //     //we're on the production site, so redirect the user to the main portal (moving him out from the iframe on the public site)
        //     window.parent.location.href = 'https://portal.artflow-pro.com';
        //   }
        // }
      } else { this.notificationsService.showNotification(this.transloco.translate('signup.errorTitle'), response.ResponseMessage, NotificationTypes.Error); }
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  private saveGallery() {
    // Create a new object with only the required properties
    const galleryData: GalleryItems = {
      // Name: this.signupForm.Name,
      FirstName: this.signupForm.FirstName,
      LastName: this.signupForm.LastName,
      UserName: this.signupForm.UserName,
      Email: this.signupForm.Email,
      Password: this.signupForm.Password,
      ConfirmPassword: this.signupForm.ConfirmPassword,
      BusinessName: this.signupForm.BusinessName,
      GalleryAddresses: []
    };

    this.ngxSpinnerService.show();
    this.galleriesService.saveGallery(galleryData).subscribe((response: ResponseObject) => {
      this.ngxSpinnerService.hide();
      if (response.Success) {
        window.parent.location.href = 'https://artflow-pro.com/thanks-for-subscribing-to-artflow/';
        //check if the angular application is running in an iframe or not
        // if (window.self === window.top) {
        //   //login now
        //   this.ngxSpinnerService.show();
        //   this.authService.login({ Username: galleryData.Email, Password: galleryData.Password }).subscribe((loginResponse: ResponseObject) => {
        //     if (loginResponse.Success) {
        //       localStorage.setItem('isNewUser', 'true');
        //       this.acceptExternalUserRequest((success: boolean) => {
        //       });
        //     }
        //     this.ngxSpinnerService.hide();
        //   }, error => { console.error(error); this.ngxSpinnerService.hide(); });
        // } else {
        //   //Open Dialog Here......
        //   this.loginDialog = true;




        //   //user is viewing the site in the iframe so navigate him properly to the portal site
        //   if (environment.production && window.parent) {
        //     console.log('Window.parent exists and I am just behind the redirection');
        //     //we're on the production site, so redirect the user to the main portal (moving him out from the iframe on the public site)
        //     window.parent.location.href = 'https://portal.artflow-pro.com';
        //   }
        // }
      } else { this.notificationsService.showNotification(this.transloco.translate('signup.errorTitle'), response.ResponseMessage, NotificationTypes.Error); }
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  public isPasswordMismatch(): boolean {
    return this.signupForm.Password !== this.signupForm.ConfirmPassword;
  }


  public signUp() {
    if (this.signupForm.AccountType === 'Artist') {
      this.saveArtist();
      // this.acceptExternalUserRequest((success: boolean) => {
      //   if (success) {
      //       //check if the angular application is running in an iframe or not
      //       if (window.self === window.top) {
      //         //not an iframe so proceed with the normal flow
      //         window.location.reload();
      //         setTimeout(() => {
      //           this.router.navigate(['/artist-onboarding-checklist']); // Redirect to artist onboarding checklist
      //         }, 100); // Delay to ensure routing happens after reload
      //       }
      //   }
      // });
    } else if (this.signupForm.AccountType === 'Gallery') {
      this.saveGallery();
      // this.acceptExternalUserRequest((success: boolean) => {
      //   if (success) {
      //     //check if the angular application is running in an iframe or not
      //     if (window.self === window.top) {
      //       window.location.reload();
      //       setTimeout(() => {
      //         this.router.navigate(['/']); // Redirect to gallery onboarding checklist
      //       }, 100); // Delay to ensure routing happens after reload
      //     }
      //   }
      // });
    }
  }
}


export class UserSignupRequest {
  Name!: string;
  FirstName!: string;
  UserName!: string;
  LastName!: string;
  Email!: string;
  Password!: string;
  ConfirmPassword!: string;
  BusinessName!: string;
  AccountType: 'Artist' | 'Gallery' = 'Artist';
}